import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import searchReducer from './slices/searchSlice';
import fraudAnalysisReducer from './slices/fraudAnalysisSlice';
import deepResearchReducer from './slices/deepResearchSlice';
import vendorReducer from './slices/vendorSlice';
import ofacReducer from './slices/ofacSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    search: searchReducer,
    fraudAnalysis: fraudAnalysisReducer,
    deepResearch: deepResearchReducer,
    vendor: vendorReducer,
    ofac: ofacReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;